import React from "react";
import "./Our_team.css";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

function Our_team() {
  const founder = [
    {
      name: "Mr. Amol Patil",
      role: "Director",
      description:
        "Amol Patil brings 13+ years of diverse experience across FMCG Sales, operations  manufacturing, Sales automation.",
      image: "/assets/images/about_us/our_team/img1.png",
      contact: "9021892042",
      email: "amolpatil@nutripair.in",
    },
    {
      name: "Mr. Keyur Neema",
      role: "Director",
      description:
        "Keyur Neema has 13+ years of experience managing multi-channel distribution and key accounts across FMCG and OTC industries. ",
      image: "/assets/images/about_us/our_team/img2.png",
      contact: "8447972998",
      email: "Keyurneema@nutripair.in",
    },
  ];

  const teamMembers = [
    {
      id: 1,
      name: "Mr. Shrikant Bhosle",
      role: "General Manager",
      description:
        "Oversees client relations and nationwide operations for automation services.",
      image: "/assets/images/about_us/our_team/Shrikant_Bhosle.png",
    },
    {
      id: 2,
      name: "Mr. Akshay Dipil Dhotre",
      role: "Marketing Head",
      description:
        "Leads marketing initiatives and manages client engagement across India.",
      image: "/assets/images/about_us/our_team/akshay.png",
    },
  ];

  const freelancers = [
    {
      id: 1,
      name: "Mr. Vishal Gaikwad",
      role: "CEO, Vishal Automation",
      description:
        "Authorised service provider for Cassida (USA). Expert in Coin Counter & Sorting Machines with pan India service coverage.",
      image: "/assets/images/about_us/our_team/vishal.png",
    },
    {
      id: 2,
      name: "Mr. Ravindra Kutal",
      role: "Freelance Marketing Consultant",
      description:
        "20 years of experience providing currency counting machine services across Maharashtra, supported by",
      image: "/assets/images/about_us/our_team/Ravindra_Kutal.png",
    },
  ];

  return (
    <section className="Our_team section_margin">
      <Container>
        {/* <h2 className="title">Our Team</h2> */}
        <Common_Title_2 titleText={"Our Team"} />

        <div className="row justify-content-center">
          {founder?.map((item) => {
            return (
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="team-card">
                  <div className="team-img-wrapper">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="team-img"
                    />
                  </div>

                  <h3 className="team-name">{item.name}</h3>
                  <h5 className="team-role">{item.role}</h5>
                  <p className="team-desc">{item.description}</p>
                  <p className="contact_text">
                    <FontAwesomeIcon icon={faPhone} className="inner_icon" />
                    {item?.contact}
                  </p>
                  <p className="contact_text">
                    <FontAwesomeIcon icon={faEnvelope} className="inner_icon" />
                    {item?.email}
                  </p>

                  {/* <div className="social-icons">
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      className="inner_icon"
                    />
                    <FontAwesomeIcon
                      icon={faInstagram}
                      className="inner_icon"
                    />
                    <FontAwesomeIcon icon={faTwitter} className="inner_icon" />
                  </div> */}
                </div>
              </div>
            );
          })}
        </div>

        {/* <Tabs
          defaultActiveKey="founder"
          id="our-team-tabs"
          className="justify-content-center mb-5"
          fill
        >
          <Tab eventKey="founder" title="Founder">
            <div className="Our_team_founder text-center mt-4">
              <div className="Our_team_founder_card">
                <div className="Our_team_founder_img_holder">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="Our_team_founder_img"
                  />
                </div>
                <div className="Our_team_founder_info">
                  <h4 className="Our_team_founder_name">{founder.name}</h4>
                  <p className="Our_team_founder_role">{founder.role}</p>
                  <p className="Our_team_founder_description">
                    {founder.description}
                  </p>
                </div>
              </div>
            </div>
          </Tab>

          <Tab eventKey="team" title="Team Members">
            <div className="Our_team_members mt-4">
              <Row className="gy-4 justify-content-center">
                {teamMembers.map((member) => (
                  <Col key={member.id} xl={4} md={6} sm={6} xs={12}>
                    <div className="Our_team_card">
                      <div className="Our_team_img_holder">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="Our_team_img"
                        />
                      </div>
                      <div className="Our_team_info_holder">
                        <h5 className="Our_team_name">{member.name}</h5>
                        <p className="Our_team_role">{member.role}</p>
                        <p className="Our_team_description">
                          {member.description}
                        </p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Tab>

          <Tab eventKey="freelancers" title="Core Team">
            <div className="Our_team_freelancers mt-4">
              <Row className="gy-4 justify-content-center">
                {freelancers.map((member) => (
                  <Col key={member.id} xl={4} md={6} sm={6} xs={12}>
                    <div className="Our_team_card freelancer">
                      <div className="Our_team_img_holder">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="Our_team_img"
                        />
                      </div>
                      <div className="Our_team_info_holder">
                        <h5 className="Our_team_name">{member.name}</h5>
                        <p className="Our_team_role">{member.role}</p>
                        <p className="Our_team_description">
                          {member.description}
                        </p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Tab>
        </Tabs> */}
      </Container>
    </section>
  );
}

export default Our_team;
